<template>
	<div>
		<div>
			<titlecom :title="organization"></titlecom>


			<div>


				<div class="left">
					<p class="title">名誉主席：</p><span class="text" v-for="(item,index) in honoraryChairman">{{item}}</span>
				</div>

				<div class="left">
					<p class="title">顾问：</p> <span class="text" v-for="(item,index) in adviser">{{item}}</span>
				</div>

				<div class="left">
					<p class="title">大会主席：</p> <span class="text" v-for="(item,index) in assembly">{{item}}</span>
				</div>

				<div class="left">
					<p class="title">大会副主席：</p> <span class="text" v-for="(item,index) in vicePresident">{{item}}</span>
				</div>

				<div class="left">
					<p class="title">学术委员会：</p> <span class="text" v-for="(item,index) in committee">{{item}}</span>
				</div>


				<div class="left">
					<p class="title">组织委员会：</p> <span class="text" v-for="(item,index) in organizing">{{item}}</span>
				</div>
				
				<div class="left">
					<p class="title">秘书长：</p> <span class="text" v-for="(item,index) in secretaryGeneral">{{item}}</span>
				</div>
				
				<div class="left">
					<p class="title">学术秘书：</p> <span class="text" v-for="(item,index) in secretary">{{item}}</span>
				</div>

			</div>


		</div>
	</div>
</template>

<script>
	import titlecom from '@/components/title/title.vue'

	export default {
		data() {
			return {
				organization: '组织机构',
				honoraryChairman: ['钟南山','汪   复' ],
				adviser: ['廖万清','夏照帆', '刘雁飞', '郭伟华', '张婴元','刘又宁' ],
				assembly: ['王明贵'],
				vicePresident: ['胡必杰', '邱海波', '徐英春', '俞云松', '卓  超'],
				committee: ['陈佰义', '陈德昌', '程璘令', '黄文祥', '黄晓军', '李家斌', '李若瑜', '刘正印', '吕晓菊', '刘晓琳', '陆权', '倪语星', '瞿介明', '施 毅', '宋 宁',
					'吴安华', '吴德沛', '王建华', '肖永红', '杨 帆', '杨文杰', '颜青', '张 菁', '朱德妹'
				],
				organizing: ['程剑剑', '褚云卓', '董亚琳', '	冯四洲',
					'甘桂芬', '高志良', '胡付品',
					'黄海辉', '黄文祥', '姜  玲', '姜淑娟', '贾  伟', '李慧灵', '李  敏',
					'李  琦', '李  昕', '李  轶', '黎毅敏', '林东昉', '刘朝晖', '马晓春',
					'马筱玲', '逄崇杰', '彭  劼', '任建安', '单  斌', '石  荔', '石松菁',
					'苏智军', '孙树梅', '孙自镛', '索  瑶', '王  椿', '王晓玲', '魏莲花',
					'席丽艳', '解立新', '许  航', '徐雪松', '徐晓刚', '喻  华', '杨小强',
					'曾  玫', '张  伟', '张湘燕', '张  玉', '赵鸣雁', '朱  镭', '宗志勇',
					'邹明祥'
				],
				secretaryGeneral: ['杨  帆','程璘令'],
				secretary: ['陈轶坚', '郭庆兰', '刘静', '余跃天']
			}
		},
		created() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (flag) {
				this.$router.push({
					path: '/organization-phone'
				})
			};
		
		},
		components: {
			titlecom,
		}
	}
</script>

<style scoped>
	.title {
		color: rgb(20, 90, 245);
		font-weight: bold;
		font-size: 16px;
		
	}
  div{
    font-size: 20px;
  }
  span{
    border: 1px solid #fff;
    display: inline-block;
    width: 3.5em;
    text-align: justify;
    line-height: 28px;
    overflow: hidden;
    height: 28px;
  }
  span::after{
    content: "";
    display: inline-block;
    width: 100%;
    height: 100%;
    border: 1px solid #fff;
  }
	.text {
		color: #333;
		font-size: 16px;
		margin-right: 20px;
		line-height: 28px;
		 /*width: 100px;*/
		display: inline-block;
	}
	.left{
		margin-left: 20px;
	}
</style>
